import React from 'react';
import Grid from '@material-ui/core/Grid';
import MultiLineBlock from '../multilineBlock/multilineBlock';
import CharacterMultiLineBlock from '../characterBlock/characterBlock';
import WordBlock from '../wordBlock/wordBlock';
import AllBlock from '../allBlock/allBlock';

import './motionView.scss';

export default class StaticView extends React.Component {

	constructor() {
		super();
		this.state = {editMode: false};
	}

	onEditModeChange = (inEditMode) => {		
		this.setState({editMode: inEditMode});
	}

	render() {

		const {
			copy,
			transitionOptions,
			fontOptions,
		} = this.props;
		
		const {editMode} = this.state;
		
	
		return (
			<Grid container direction="column" justify="center" alignItems="center" style={{pointerEvents: 'none', userSelect: 'none'}}>
				<div className="staticView">
	
					{transitionOptions.reveal === 'character' && (					
						<CharacterMultiLineBlock
                            staticView
							fontOptions={fontOptions}
							transitionOptions={transitionOptions}
							copy={copy}
							onEditModeChange={this.onEditModeChange}
                            inEditMode={editMode}
						/>
					)}
	
	
					{transitionOptions.reveal === 'word' && (
						<WordBlock
                            staticView
							fontOptions={fontOptions}
							transitionOptions={transitionOptions}
							copy={copy}
							onEditModeChange={this.onEditModeChange}
							inEditMode={editMode}
						/>
					)}
	
					{transitionOptions.reveal === 'multiline' && (
                        <MultiLineBlock 
                            staticView
							fontOptions={fontOptions}
							transitionOptions={transitionOptions}
							copy={copy}
							onEditModeChange={this.onEditModeChange}
							inEditMode={editMode}
						/>
					)}
	
					{transitionOptions.reveal === 'all' && (
						<AllBlock
                            staticView
							fontOptions={fontOptions}
							transitionOptions={transitionOptions}
							copy={copy}
							onEditModeChange={this.onEditModeChange}
						/>
					)}
				</div>
			</Grid>
		)
	}
}